import { render, staticRenderFns } from "./ContentWidth.vue?vue&type=template&id=7d3c1ccb&"
import script from "./ContentWidth.vue?vue&type=script&lang=js&"
export * from "./ContentWidth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports